import { render } from "./AddTeilnehmerZugriffDialog.vue?vue&type=template&id=0a529b59&ts=true"
import script from "./AddTeilnehmerZugriffDialog.vue?vue&type=script&lang=ts"
export * from "./AddTeilnehmerZugriffDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__